import React from 'react';
import {InsightInterval, OperatorEngagementInsight} from "types/OperatorInsights";
import {ChartData, ChartOptions} from "chart.js";
import {toTitleCase} from "services/string";
import {Line as LineChart} from "react-chartjs-2";
import {Duration} from "luxon";
import HoverAnnotation from "../../../plugins/hover-annotation";


function formatSeconds(seconds: number): string {
    return Duration.fromObject({hours: 0, minutes: 0, seconds}).normalize().toFormat("h'h', m'm'")
}

type Props = {
    data: OperatorEngagementInsight
    interval: InsightInterval
    compare: InsightInterval
}

function VisitDurationChart({compare, data, interval}: Props) {

    const chartData: ChartData<'line', any> = {
        labels: data.metrics.map(metric => metric.time),
        datasets: [
            {
                label: "Current period",
                backgroundColor: "rgba(99, 102, 241, 0.8)",
                borderColor: "rgba(79, 70, 229, 1)",
                pointBackgroundColor: "rgba(99, 102, 241, 1)",
                data: data.metrics.map(metric => metric.measurements.average_visit_duration.value),
            },
            {
                label: `Previous ${compare}`,
                backgroundColor: "rgba(99,102,241,0.4)",
                borderColor: "rgba(79, 70, 229, 0.4)",
                pointBackgroundColor: "rgba(99, 102, 241, 0.4)",
                data: data.metrics.map(metric => metric.measurements.average_visit_duration.comparison),
            }
        ],
    }

    const chartOptions: ChartOptions<'line'> = {
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                mode: "index",
                intersect: false,
                callbacks: {
                    label: tooltipItem => `${tooltipItem.dataset.label}: ${formatSeconds(Number(tooltipItem.raw))}`
                }
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: toTitleCase(interval)
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Visit Duration'
                },
                grid: {
                    display: true
                },
                min: 0,
                ticks: {
                    callback: tickValue => formatSeconds(Number(tickValue))
                }
            }
        }
    }

    return (
        <LineChart data={chartData} options={chartOptions} plugins={[HoverAnnotation]} />
    );
}

export default VisitDurationChart;